import { render, staticRenderFns } from "./JSONErrorVisualizer.vue?vue&type=template&id=47910902&"
import script from "./JSONErrorVisualizer.vue?vue&type=script&lang=js&"
export * from "./JSONErrorVisualizer.vue?vue&type=script&lang=js&"
import style0 from "./JSONErrorVisualizer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports